// extracted by mini-css-extract-plugin
export default {"logo":"ApplicationLogo_logo__pjN4E"};